import { useSelector } from "@shared/hooks/shared/useTypedSelector";
import { ILanguages } from "@shared/services";

export const useLobbyParams = () => {
  return useSelector(({ lobby }: TRootState) => lobby.params);
};

export const useLobbyLanguages = () => {
  return useSelector(({ lobby }: TRootState): ILanguages => lobby.languages);
};

export const useModalContactsIsShow = (): boolean => {
  return useSelector(({ lobby }: TRootState) => lobby.showContactsModal);
};

export const useModalInfoIsShow = (): boolean => {
  return useSelector(({ lobby }: TRootState) => lobby.showInfoModal);
};

export const useModalSportBetsHistoryIsShow = (): boolean => {
  return useSelector(
    ({ lobby }: TRootState) => lobby.showSportBetsHistoryModal
  );
};

export const useBanners = (): boolean => {
  return useSelector(({ lobby }: TRootState) => lobby?.slider?.banners);
};

export const useModalRulesState = () => {
  return useSelector(({ lobby }: TRootState) => lobby.rulesModal);
};
